import { render } from "./PublicationProPlans.vue.js?vue&type=template&id=9615f330!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProPlans.vue?vue&type=template&id=9615f330"
import script from "./PublicationProPlans.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProPlans.vue?vue&type=script&lang=js"
export * from "./PublicationProPlans.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProPlans.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/pro-features/PublicationProPlans.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9615f330"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9615f330', __exports__)) {
    api.reload('9615f330', __exports__)
  }
  
  module.hot.accept("./PublicationProPlans.vue.js?vue&type=template&id=9615f330!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationProPlans.vue?vue&type=template&id=9615f330", () => {
    api.rerender('9615f330', render)
  })

}


export default __exports__